
import { Options, Vue } from 'vue-class-component';
import ModalBox from '@/shared/components/modal-box/index.vue';
import { Inject, Prop } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from 'events';
import store from '../../../store';
import { BankRequest, BankView, Status } from '@/shared/modules/typescript-trustapi-client/models';

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
  }
})
export default class AddEditBankModal extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'statusType', default: [] })
  private statusType!: Status[];

  @Prop({ default: {}})
  private bank!: BankView;
  private formData: BankView = {};

  private status = 1;
  private submitting = false;
  private loadingContent = false;
  private errorLoadingContent = false;
  private showCancelAlert = false;


  created(): void {
    this.formData = JSON.parse(JSON.stringify(this.bank));

    if (this.editMode) {
      this.status = this.formData.status.id;
    } else {
      this.formData.status = {
        id: 1
      }
    }
  }

  private async saveBank(): Promise<void> {
    try {
      if (!this.validForm && !this.isFormDirty) {
        throw new Error('Invalid Data Filled');
      }  
      this.submitting = true;
      this.formData.status = {
        id: this.status
      }
      const bankReq: BankRequest = {
        id: this.formData.id,
        name: this.formData.name,
        description: this.formData.description,
        statusId: this.formData.status?.id
      };
      await this.apiService.ConfigTrustApi?.apiV2ConfigTrustSaveBankPost(bankReq);
      this.eventCtrl.emit('reload-banks');

      if(bankReq.id == 0) {
        this.eventCtrl.emit('show-snackbar', 'success', 'Added Successfully');
      } else {
        this.eventCtrl.emit('show-snackbar', 'success', 'Updated Successfully');
      }
  
      this.closeModal();
    } catch(err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Unable to process request');
    } finally {
      this.submitting = false;
    }
  }

  private closeModal() {
    this.$emit('closeAddEditBankModal');
  }

  get validForm(): boolean {
    try {
      return this.formData.name.trim() &&
      this.formData.name.trim().length <= 200 &&
      this.status;
    } catch {
      return false;
    }
  }

  get isFormDirty(): boolean {
    if (this.editMode) {
      const modifiedAppName = this.bank.name !== this.formData.name;
      const modifiedStatus = this.bank.status.id !== this.status;
      return modifiedAppName || modifiedStatus;
    } else {
      return !!this.formData.name && this.formData.name.length > 0;
    }
  }

  get editMode(): boolean {
    return this.bank?.id > 0;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

}

